import { render, staticRenderFns } from "./BaseRemind.vue?vue&type=template&id=252bc7f7&scoped=true"
import script from "./BaseRemind.vue?vue&type=script&lang=js"
export * from "./BaseRemind.vue?vue&type=script&lang=js"
import style0 from "./BaseRemind.vue?vue&type=style&index=0&id=252bc7f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bc7f7",
  null
  
)

export default component.exports